// Bizsprite visual vocabulary; product runtime and API identifiers remain unchanged.
const colors = {
  surface: { canvas: '#F5F7FA', content: '#FFFFFF', darkCanvas: '#0F172A', darkContent: '#111827' },
  ink: { primary: '#172033', secondary: '#5B6575', inverted: '#F3F4F6' },
  line: '#DCE2EA',
  // Background Colors - Bright Light Theme
  gray: {
    900: '#172033', // Dark text (primary)
    850: '#263449', // Darker text
    800: '#334155', // Secondary text
    700: '#5B6575', // Muted text
    600: '#5B6575', // Disabled text
    500: '#64748B', // Strong borders (darkened from #CBD5E0)
    400: '#94A3B8', // Medium borders (darkened from #E2E8F0)
    300: '#DCE2EA', // Light borders (darkened from #EDF2F7)
    200: '#F5F7FA', // Subtle background
    100: '#F8FAFC', // Card background
    50: '#FFFFFF',  // Pure white background
  },

  // Standard blue colors for user interface
  blue: {
    50: '#EBF8FF',
    100: '#BEE3F8',
    200: '#90CDF4',
    300: '#63B3ED',
    400: '#4299E1',
    500: '#2563EB',
    600: '#1D4ED8',
    700: '#2C5282',
    800: '#2A4365',
    900: '#1A365D',
  },

  // Orange colors for admin interface
  orange: {
    50: '#FFFBEB',
    100: '#FEF3C7',
    200: '#FDE68A',
    300: '#FCD34D',
    400: '#FBBF24',
    500: '#F59E0B',
    600: '#D97706',
    700: '#B45309',
    800: '#92400E',
    900: '#78350F',
  },

  // Green colors for success states
  green: {
    50: '#F0FDF4',
    100: '#DCFCE7',
    200: '#BBF7D0',
    300: '#86EFAC',
    400: '#4ADE80',
    500: '#22C55E',
    600: '#16A34A',
    700: '#15803D',
    800: '#166534',
    900: '#14532D',
  },

  // Red colors for error states
  red: {
    50: '#FEF2F2',
    100: '#FEE2E2',
    200: '#FECACA',
    300: '#FCA5A5',
    400: '#F87171',
    500: '#EF4444',
    600: '#DC2626',
    700: '#B91C1C',
    800: '#991B1B',
    900: '#7F1D1D',
  },

  // Text Colors - Bright Theme
  text: {
    primary: '#172033',   // Primary text - deep black for readability
    secondary: '#334155', // Secondary text - medium gray
    muted: '#5B6575',     // Muted text - lighter gray
    light: '#5B6575',     // Very light text
    inverted: '#FFFFFF',  // White text for dark backgrounds
  },

  // Brand & Accent Colors
  brand: {
    blue: {
      50: '#EBF8FF',
      100: '#BEE3F8',
      200: '#90CDF4',
      300: '#63B3ED',
      400: '#4299E1',
      500: '#2563EB', // User view primary - slightly deeper for better contrast
      600: '#1D4ED8', // Hover - darker
      700: '#2C5282',
      800: '#2A4365',
      900: '#EFF6FF', // Selected row background - lighter
    },
    orange: {
      500: '#FA8C16', // Admin view primary
      600: '#D97A0F', // Hover
    },
    navy: '#001529', // Admin sidebar background
  },

  // Chat-specific colors
  chat: {
    userBubble: '#2563EB',      // User messages - matches brand blue
    aiBubble: '#F5F7FA',        // AI messages - light gray
    userText: '#FFFFFF',        // Text in user bubbles
    aiText: '#172033',          // Text in AI bubbles
    timestamp: '#5B6575',       // Timestamp text
    divider: '#E2E8F0',         // Date dividers
    inputBorder: '#CBD5E0',     // Message input border
    inputFocus: '#2563EB',      // Active input border
    hover: 'rgba(49, 130, 206, 0.05)',  // Hover state
    active: 'rgba(49, 130, 206, 0.1)',  // Active/pressed state
  },

  // Semantic Colors
  success: '#52C41A',
  warning: '#FAAD14',
  error: '#FF4D4F',

  // Chart & Series Colors
  series: {
    yellow: '#Fadb14',
    purple: '#722ED1',
    cyan: '#13C2C2',
  },
};

export default colors;
